export const queryParams = (obj) => {
    let params = '';
    for (var key in obj) {
        const item = obj[key];
        if (item) {
            params = params
                ? `${params}&${key}=${item}`
                : `${key}=${item}`;
        }
    }
    return params;
};

export const titleCase = (name) => {
    const nameParts = name.split(' ');
    let titleCase = '';
    for (let i = 0; i < nameParts.length; i++) {
        titleCase += (i > 0 ? ' ' : '') + nameParts[i].substr(0, 1).toUpperCase() + nameParts[i].substr(1).toLowerCase();
    }
    return titleCase;
};


export const getInitial = (name) => {
    if (name !== null && name.length > 0) {
        return name[0].toUpperCase();
    }
    else {
        return name;
    }
};


export const reduceSpaces = (someString) => {
    if (someString !== null) {
        while (someString.indexOf('  ') > -1) {
            someString = someString.replace('  ', ' ');
        }
    }
    return someString;
};


export const getInitials = (diplayName) => {
    let name = reduceSpaces(diplayName).trim();
    let firstInitial = '', lastInitial = '';
    if (name.indexOf(',') > -1) {
        let parts = name.split(',');
        firstInitial = getInitial(parts[1].trim());
        lastInitial = getInitial(parts[0].trim());
    }
    else {
        let parts = name.split(' ');
        firstInitial = getInitial(parts[0].trim());
        if (parts.length > 1) {
            lastInitial = getInitial(parts[1].trim());
        }
    }
    return firstInitial + lastInitial;
};



export const getFirstName = (diplayName) => {
    let name = diplayName.trim();
    if (name.indexOf(',') > -1) {
        let first = name.split(',')[1];
        return first.trim().split(' ')[0];
    }
    else {
        return name.split(' ')[0];
    }
};

export const getSecondName = (diplayName) => {
    let name = diplayName.trim();
    if (name.indexOf(',') > -1) {
        let second = name.split(',')[0];
        return second.trim();
    }
    else if (name.indexOf(' ') > -1) {
        return name.split(' ')[1];
    }
    return null;
};

export const firstNameFirst = (diplayName) => {
    let name = diplayName.trim();
    const commaIndex = name.indexOf(',');
    if (commaIndex > -1) {
        const last = name.substr(0, commaIndex).trim();
        const first = name.substr(commaIndex + 1).trim();
        return titleCase(first + ' ' + last);
    }
    else {
        return titleCase(name);
    }
};

export const lastNameFirst = (diplayName) => {
    let name = diplayName.trim();
    if (name.indexOf(',') > -1) {
        name = name.replace(',', ', ');
    }

    return titleCase(name)
};

export const formatDoctorName = (displayName) => {
    let fullName = '';
    if (displayName) {
        let displayNameArr = displayName.split(',');
        if (displayNameArr.length > 2) {
            fullName = displayNameArr[1] + ' ' + displayNameArr[0] + ',' + displayNameArr[2];
        } else if (displayNameArr.length > 1) {
            fullName = displayNameArr[1] + ' ' + displayNameArr[0];
        } else if (displayNameArr.length > 0) {
            fullName = displayNameArr[0]
        }
    }
    return fullName;
};

export const formatPhoneNumber = (phone) => {
    const cleaned = ('' + phone).replace(/\D/g, '');
    if (cleaned.length > 10) {
        const ccLength = cleaned.length - 10; // ccLength: country code length
        return `+${cleaned.substr(0, ccLength)} ${cleaned.substr(ccLength, 3)}.${cleaned.substr(ccLength + 3, 3)}.${cleaned.substr(ccLength + 6)}`;
    }
    else {
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return match[1] + '.' + match[2] + '.' + match[3];
        }
    }
    return '';
};

export const phoneFormattedWithMDash = (phone) => {
    phone = ('' + phone).replace(/\D/g, '');
    const mDash = '—';
    const lenOfInput = phone.length;
    const isCountryCode = phone.charAt(0) === '1' ? true : false;
    if (isCountryCode) {
        switch (lenOfInput) {
            case 1:
                break;
            case 2: case 3: case 4:
                phone = phone.slice(0, 1) + " (" + phone.slice(1) + ") ";
                break;
            case 5: case 6: case 7:
                phone = phone.slice(0, 1) + " (" + phone.slice(1, 4) + ") " + phone.slice(4);
                break;
            case 8: case 9: case 10: case 11:
                phone = phone.slice(0, 1) + " (" + phone.slice(1, 4) + ") " + phone.slice(4, 7) + mDash + phone.slice(7);
                break;
            default:
                phone = phone.slice(0, 1) + " (" + phone.slice(1, 4) + ") " + phone.slice(4, 7) + mDash + phone.slice(7, 11);
        }
    }
    else {
        switch (lenOfInput) {
            case 1: case 2: case 3:
                break;
            case 4: case 5: case 6: case 7:
                phone = phone.slice(0, 3) + mDash + phone.slice(3);
                break;
            case 8: case 9: case 10:
                phone = "(" + phone.slice(0, 3) + ") " + phone.slice(3, 6) + mDash + phone.slice(6);
                break;
            default:
                phone = "(" + phone.slice(0, 3) + ") " + phone.slice(3, 6) + mDash + phone.slice(6, 10);
        }
    }
    return phone;
};

export const rxRoute = (routeName) => {
    let prefix = '/';
    if (typeof window !== 'undefined' && window.serverData.data.bundle !== 'pharmacy' &&
        window.location.href.toLowerCase().indexOf('localhost') > -1) {
        prefix = '/pharmacy';
    }
    if (routeName && routeName[0] === '/') {
        routeName = routeName.substr(1);
    }
    return prefix + routeName;
};

const rxPath = /\brxlist|\brxrefill|\brxtransfer|\bbswtransfer|\bnonbswtransfer|\bfindpharmacy/;

export const isRxRoute = (pathname) => {
    const prefix = '/pharmacy';
    let pathToCheck = pathname.toLowerCase();
    if (typeof window !== 'undefined' && window.location.href.toLowerCase().indexOf('localhost') > -1 &&
        pathToCheck.indexOf(prefix) === 0) {
        pathToCheck = pathToCheck.substr(prefix.length);
    }
    return rxPath.test(pathToCheck);
};

export const getCsnId = (activePath) => {
    const videoPageUrl = "/providervideovisit";
    const startString = videoPageUrl.length + 1;
    const newPath = activePath.toLowerCase().substring(startString);
    const endString = (newPath.indexOf("?" || "/") !== -1) ? newPath.indexOf("?" || "/") : activePath.length;
    const csnId = newPath.substring(0, endString - 1).replace('/samedaycare', '').replace('/', '');
    return csnId;
};
